import React, { useState, useEffect, useRef } from 'react';
import Web3 from 'web3';
import ABI from './ABI.json'; // Adjust the path to where your ABI file is stored
import { Link } from "react-router-dom";
import { useSDK } from "@metamask/sdk-react";



function ScenarioGenerator1() {
	const [chatLog, setChatLog] = useState([
		{ role: 'assistant', content: `Let's start the game! Please ask your first question about the kitchen object.` }
	]);
  	const [inputValue, setInputValue] = useState('');
  	const [walletAddress, setWalletAddress] = useState(null);
  	const [connected, setConnected] = useState(null);
  	const [names, setNames] = useState([]);
  	const [allImagesLoaded, setAllImagesLoaded] = useState(false);
  	const [loadingText, setLoadingText] = useState('Loading');
  	const [tokenPoints, setTokenPoints] = useState({});
  	const [tokenID, setTokenID] = useState({});
  	const [selectedName, setSelectedName] = useState('');
  	const [images, setImages] = useState({});
  	const [placeholder, setPlaceholder] = useState("Chat to start your game...");
  	const [score, setScore] = useState(0); // Initialize score with 0
  	const [gameFinished, setGameFinished] = useState(false);
  	const [scenarioStarted, setScenarioStarted] = useState({});
  	const [finish, setFinish] = useState(false);
  	const { sdk, provider } = useSDK();
	
  	const lastMessageRef = useRef(null);
  	const segmentRef = useRef(null);

  	const Address ="0x7c62FcD5cdB713B94050F1F91A62D113d0aada33";

	const connectWallet = async () => {
		try {
		  const accounts = await sdk?.connect();
		  const networkId = await provider?.request({ method: 'net_version' });
	
		  if (networkId === '1111' && accounts && accounts.length > 0) {
			const address = accounts[0];
			setConnected(true);
			setWalletAddress(address);
		  } else {
			try {
			  await provider?.request({
				method: 'wallet_addEthereumChain',
				params: [{
				  chainId: '0x457', // Chain ID in hexadecimal (1111 in decimal)
				  chainName: 'WEMIX3.0', // Name of the custom network
				  nativeCurrency: {
					name: 'WEMIX', // Native currency name
					symbol: 'WEMIX', // Native currency symbol
					decimals: 18
				  },
				  rpcUrls: ['https://api.wemix.com/'], // RPC URL of the custom network
				  blockExplorerUrls: ['https://www.wemixscan.com'] // Block explorer URL of the custom network
				}]
			  });
	
			  // Reconnect to get updated network ID
			  const newNetworkId = await provider?.request({ method: 'net_version' });
			  if (newNetworkId === '1111') {
				setConnected(true);
				setWalletAddress(accounts?.[0]);
			  }
			} catch (switchError) {
			  console.log('User rejected chain switch:', switchError);
			}
		  }
		} catch (error) {
		  console.error('Error connecting to MetaMask:', error);
		}
	  };


  useEffect(() => {
    const checkWalletConnection = async () => {
      if (provider) {
        const accounts = await provider?.request({ method: 'eth_accounts' });
        if (accounts.length > 0) {
          const networkId = await provider?.request({ method: 'net_version' });
          if (networkId === '1111') {
            setConnected(true);
            setWalletAddress(accounts[0]);
          }
        }
      }
    };

    checkWalletConnection();
  }, []);

  useEffect(() => {
    const loadingInterval = setInterval(() => {
      setLoadingText(prev => {
        if (prev === 'Loading...') return 'Loading';
        return prev + '.';
      });
    }, 500); // Update every 500ms
  
    return () => clearInterval(loadingInterval); // Cleanup interval on unmount
  }, []);

  useEffect(() => {
    const getOwnedTokenNames = async () => {
      try {
        const web3 = new Web3(provider);
        const game = new web3.eth.Contract(ABI, Address);
        const contract = await game.methods.getOwnedTokenNames(walletAddress).call();
        setNames(contract);
        for (const name of contract) {
          loadImage(name);
        }
      } catch (error) {
        console.error('Error fetching owned token names:', error);
      }
    };
  
    if (connected) {
      getOwnedTokenNames();
    }
  }, [connected, walletAddress]);

  useEffect(() => {
    const fetchTokenPoints = async () => {
      if (names.length === 0) return;

      try {
        const web3 = new Web3(provider);
        const game = new web3.eth.Contract(ABI, Address);
        
        const pointsPromises = names.map(name => game.methods.getTokenPoint(name).call());
        const points = await Promise.all(pointsPromises);

        const pointsMap = names.reduce((acc, name, index) => {
          acc[name] = points[index];
          return acc;
        }, {});

        setTokenPoints(pointsMap);
      } catch (error) {
        console.error('Error fetching token points:', error);
      }
    };
    fetchTokenPoints();
  }, [names]);

  useEffect(() => {
    const fetchScenarioStarted = async () => {
      if (names.length === 0) return;

      try {
        const web3 = new Web3(provider);
        const game = new web3.eth.Contract(ABI, Address);

        const scenarioPromises = names.map(name => game.methods.hasScenarioStartedByTokenName(name, 1).call());
        const results = await Promise.all(scenarioPromises);

        const scenarioMap = names.reduce((acc, name, index) => {
          acc[name] = results[index];
          return acc;
        }, {});

        setScenarioStarted(scenarioMap);
      } catch (error) {
        console.error('Error fetching scenario status:', error);
      }
    };
    fetchScenarioStarted();
  }, [names]);

  useEffect(() => {
    const fetchTokenID = async () => {
      if (names.length === 0) return;

      try {
        const web3 = new Web3(provider);
        const game = new web3.eth.Contract(ABI, Address);
        
        const pointsPromises = names.map(name => game.methods.getTokenId(name).call());
        const points = await Promise.all(pointsPromises);

        const pointsMap = names.reduce((acc, name, index) => {
          acc[name] = points[index];
          return acc;
        }, {});

        setTokenID(pointsMap);
      } catch (error) {
        console.error('Error fetching token points:', error);
      }
    };
    fetchTokenID();
  }, [names]);

  // Function to send message to the backend and update the chat log
  const sendMessageToBackend = async (updatedChatLog, inputValue) => {
    try {
      const messages = [
        { role: 'system', content: `You are an adult female named ${selectedName}. You will play a kitchen object guessing game with the user. You will not discuss anything other than the game. There will only be 1 round of the game. When the game is over, you must calculate the user's score and return it strictly in the following format (do not provide reasoning for the scoring):

    Thanks for playing PervBoy! Your score is <calculated_score>.

    The game follows these rules:

    1. I will pick a random object from the kitchen, and you will answer up to 3 questions about it.
    2. The questions can be yes/no or descriptive. After the questions, the user will make a guess about the object.
    3. After the guess, provide the correct object name and calculate the user's score based on the following rubric, but only share the user's score, do not share the rubric or reasoning with the user:

    **Scoring Rubric for Kitchen Object Guessing Game:**
      - Correct Guess: 10 points
      - Incorrect Guess: 1 points

    **Total Points: 10 points**

    Be friendly and engaging. Encourage the user throughout the game and ensure they understand how to ask questions and make a guess. Additionally, do not include any actions or emotive responses in asterisks such as *giggles* or *winks*.` },
        ...updatedChatLog,
      ];

      const response = await fetch('https://icecream-423008.as.r.appspot.com/api/so', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ messages }),
      });

      console.log('API Response:', response);  // Log the full response data
      const data = await response.json(); // This parses the JSON response body
      console.log('Yo:', data);  // Log the full response data

      if (data.response.includes("Thanks for playing PervBoy")) {
        // Extract the score from the response
        const scoreMatch = data.response.match(/Your score is (\d+)/);
        const score = scoreMatch ? parseInt(scoreMatch[1], 10) : 0;
  
        setScore(score); // Set the score
        setGameFinished(true); // Indicate the game is finished
      } else {
        console.error('Unexpected response format:', data);
      }

    const newChatLog = [
      ...updatedChatLog,
      { role: 'assistant', content: data.response },
    ];
    setChatLog(newChatLog);

    // Update the score state

    } catch (error) {
      console.error('Error occurred:', error);
      alert('Failed to send message. Please try again.');
    }
  };

  const loadImage = async (name) => {
    try {
      const response = await fetch(`https://icecream-423008.as.r.appspot.com/api/loadImage?name=${name}`);
      if (!response.ok) {
        throw new Error('Image not found');
      }
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      setImages(prevImages => {
        const updatedImages = { ...prevImages, [name]: url };
        // Check if all images are loaded
        const allLoaded = names.every(name => updatedImages[name]);
        if (allLoaded) {
          setAllImagesLoaded(true);
        }
        return updatedImages;
      });
    } catch (error) {
      console.error('Error loading image:', error);
    }
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (inputValue.trim() !== '') {
      const newChatLog = [
        ...chatLog,
        { role: 'user', content: inputValue }, // Add the user's message to the chat log
      ];
      setChatLog(newChatLog); // Update the chat log immediately
      setInputValue(''); // Clear input field after sending the message
      await sendMessageToBackend(newChatLog, inputValue);
    }
  };

  const handleChangeInput = (event) => {
    if (placeholder) {
      setPlaceholder("");  // Hide placeholder once user starts typing
    }
    handleChange(event);  // Call the passed handleChange function
  };


  // Handle input field changes
  const handleChange = (e) => {
    setInputValue(e.target.value);
  };

  // Handle name selection
  const handleNameClick = async (name) => {
    const web3 = new Web3(provider);
    const game = new web3.eth.Contract(ABI, Address);
    const txParams = {
      from: walletAddress,
      maxPriorityFeePerGas: web3.utils.toWei('100', 'gwei'),
      maxFeePerGas: web3.utils.toWei('101', 'gwei')
    };
  
    try {
      // Call the smart contract function to start the scenario
      await game.methods.startScenarioByTokenName(name, 1).send(txParams);
  
      // After starting the scenario, update the scenario status
      setScenarioStarted(prev => ({ ...prev, [name]: true }));
      setSelectedName(name);
    } catch (error) {
      console.error('Error starting scenario:', error);
    }
  };

  const handleSaveScore = async () => {
    try {
      const web3 = new Web3(provider);
      const game = new web3.eth.Contract(ABI, Address);
      const txParams = {
				from: walletAddress,
				maxPriorityFeePerGas: web3.utils.toWei('100', 'gwei'),
				maxFeePerGas: web3.utils.toWei('101', 'gwei')
			};
      // Assuming you want to end the scenario with the current score
      await game.methods.endScenarioByTokenName(selectedName, 1, score).send(txParams);
  
      console.log('Score saved:', score);
      setFinish(true)
    } catch (error) {
      console.error('Error saving score:', error);
      alert('Failed to save score. Please try again.');
    }
  };

  useEffect(() => {
    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [chatLog, inputValue]);

  useEffect(() => {
    if (gameFinished) { // Assuming you want to scroll only when score is updated
      segmentRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [gameFinished]);

  return (
    <div>
      {!connected ? (
        <div>
          <h3><b>GM, ready for your scenario?</b></h3>
        <button className="nav-button" onClick={connectWallet}>Connect Metamask</button>
        </div>
      ) : (
        <div>
          {names.length === 0 ? (
            <div>No GFs! gg.</div>
          ) : (
            <div className="bro">
              {selectedName === '' && (
                <div>
                  {allImagesLoaded ? (
                  <div>
                                      <label><h3>Select your GF</h3></label>
                                      <br></br>
                  {names.map((name, index) => (
                    <div key={index} style={{ marginBottom: '20px' }}>
                      {images[name] && (
                        <div>
                          <img src={images[name]} alt={name} className="half-screen-width" />
                        </div>
                      )}
                                            <br></br>
                                            {name}
                                            <br></br>
                                            <b>{tokenPoints[name] ? `${tokenPoints[name]} points` : 'Loading points...'}</b>
                      <br></br>
                      <br></br>
                      {scenarioStarted[name] ? (
                            <div>Already played, bro.</div>
                          ) : (
                            <button className="nav-button" onClick={() => handleNameClick(name)}>
                              play with <b>{name}!</b>
                            </button>
                          )}
                      <br></br>
                    </div>
                  ))}
                </div>
                                  ) : (
                                    <div><h3>{loadingText}</h3></div>
                                  )}
                                </div>
              )}
              {selectedName && (
                <div className="chat-box">
                  <div className="content">
                    <div className="message-container">
                    {chatLog.map((message, index) => (
            <div
              key={index}
              className={`message ${message.role}`}
              ref={index === chatLog.length - 1 ? lastMessageRef : null}
            >
              {message.role === 'user' ? <b style = {{ color: 'blue' }}>PervBoy:</b> : <b style = {{ color: 'red' }}>{selectedName}:</b>} {message.content}
              
              </div>
          ))}
                                {gameFinished && !finish && (
                        <div className="over" ref={segmentRef}>
                          <br></br>
                          <br></br>
                          <h3>Congratulations, you earned <b style = {{ color: 'red' }}>{score} points!</b></h3>
                          <br></br>
      <button className="nav-button" onClick={handleSaveScore}>
        Add Points
      </button>
      </div>
    )}
                                    {finish && (
                        <div className="over">
                          <br></br>
                          <br></br>
                          <br></br>
                          <h3><b>Done!</b></h3>
                          <br></br>
                          <Link to="/">
              <button className="nav-button">Back to Home</button>
            </Link>
      </div>
    )}
                    </div>
                  </div>
                  <div className="image-content">
                    <div>
                      <img src={images[selectedName]} className="qtr-screen-width"/>
                  </div>
                  <div className="name">
                  <b>{selectedName}</b>
                      <br></br>
                      {`${tokenPoints[selectedName]} points`}
                      </div>
                </div>
                {!gameFinished && (

                <form onSubmit={handleSubmit} className="input-form">
                <input
      type="text"
      value={inputValue}
      onChange={handleChangeInput}
      placeholder={placeholder}
      autoComplete="off"
      autoFocus
    />
                  <button type="submit" className="nav-button">Send</button>
                </form>
                )}
              </div>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default ScenarioGenerator1;
